import { initAccordion } from './modules/accordion.js';
import { initCollapsibleSection } from './modules/collapsible-section.js';
import { initNavMenu } from './modules/nav-menu.js';
import { initToc, initTocbot, initTocReposition } from './modules/toc.js';
import { initIconSlider } from './modules/icon-slider.js';
import { initGridMenu } from './modules/grid-menu.js';
import { initTestimonialSlider } from './modules/testimonial-slider.js';
import { initFeaturedGuideSlider } from './modules/featured-guide-slider.js';
import { initRelatedPagesSlider } from './modules/related-pages-slider.js';
import { initPageTeasers } from './modules/page-teasers.js';
import { initExpandableText } from './modules/expandable-text.js';
import { initContentCardsSlider } from './modules/content-cards-slider.js';
import { initArticleGridSlider } from './modules/article-grid-slider.js';
import { initSocialSharing } from './modules/social-sharing.js';
import { initPopupTrigger } from './modules/popup-trigger.js';
import { initTextCopy } from './modules/text-copy.js';
import { initCampaignQuiz } from './modules/campaign-quiz.js';
import { initSearchResults } from './modules/search-results.js';
import { initNewsletterSignup } from './modules/newsletter-signup.js';

document.addEventListener('DOMContentLoaded', () => {
  initToc(document);
  initTocbot(document);
  initTocReposition();
  initAccordion(document);
  initCollapsibleSection(document);
  initNavMenu(document);
  initIconSlider(document);
  initGridMenu(document);
  initTestimonialSlider(document);
  initFeaturedGuideSlider(document);
  initRelatedPagesSlider(document);
  initPageTeasers(document);
  initExpandableText(document);
  initContentCardsSlider(document);
  initArticleGridSlider(document);
  initSocialSharing(document);
  initPopupTrigger(document);
  initTextCopy(document);
  initCampaignQuiz(document);
  initSearchResults(document);
  initNewsletterSignup(document);
});

document.addEventListener('bricks/element/render', (event) => {
  const el = event.detail && event.detail.element ? event.detail.element : null;
  if (el) {
    initToc(el);
    initTocbot(el);
    initAccordion(el);
    initCollapsibleSection(el);
    initNavMenu(el);
    initIconSlider(el);
    initGridMenu(el);
    initTestimonialSlider(el);
    initFeaturedGuideSlider(el);
    initRelatedPagesSlider(el);
    initPageTeasers(el);
    initExpandableText(el);
    initContentCardsSlider(el);
    initArticleGridSlider(el);
    initSocialSharing(el);
    initTextCopy(el);
    initCampaignQuiz(el);
    initSearchResults(el);
    initNewsletterSignup(el);
  }
});
